import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import logo from '../../assets/logo.png';
import menu from '../../assets/menu-icon.png';
import closeMenu from '../../assets/close-menu-icon.png';
import arrowDown from '../../assets/arrow-down-icon.png'; 
import './Navbar.css';

const Navbar = () => {
  const [sticky, setSticky] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1350);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', () => {
      window.scrollY > 50 ? setSticky(true) : setSticky(false);
    });

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleMenu = () => {
    setMobileMenu(!mobileMenu);
    setDropdownOpen(false);
  };

  const handleDropdownClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      setDropdownOpen(!dropdownOpen);
    }
  };

  const handleDropdownEnter = () => {
    if (!isMobile) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setDropdownOpen(true);
    }
  };

  const handleDropdownLeave = () => {
    if (!isMobile) {
      timeoutRef.current = setTimeout(() => {
        setDropdownOpen(false);
      }, 300);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('nav')) {
        setMobileMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <nav className={`nav-container ${sticky ? 'dark-nav' : ''}`}>
      <Link to='/' className="nav-logo">
        <img src={logo} alt="logo" className="logo" />
      </Link>
      
      <ul className={`nav-items ${mobileMenu ? 'show-mobile-menu' : ''}`}>
        <li><Link to='/'>Home</Link></li>
        <li><Link to='/about'>About</Link></li>
        <li
          className={`dropdown ${dropdownOpen ? 'dropdown-active' : ''}`}
          onMouseEnter={handleDropdownEnter}
          onMouseLeave={handleDropdownLeave}
          onClick={handleDropdownClick}
        >
          <span className="dropdown-trigger">
            Programs <img src={arrowDown} alt="arrow down" className={`arrow-down-icon ${dropdownOpen ? 'rotate' : ''}`} />
          </span>
          <ul className={`dropdown-content ${dropdownOpen ? 'show' : ''}`}>
            <li><Link to='/ambassadors'>Campus Ambassadors Program</Link></li>
            <li><Link to='/wiq'>Women in Quantum Program</Link></li>
            <li><Link to='/bootcamps'>Bootcamp Programs</Link></li>
          </ul>
        </li>
        <li>
            <a href="https://lu.ma/user/quantumke_org" target="_blank" rel="noopener noreferrer">
              Events
            </a>
        </li>
        <li>
            <a href="https://medium.com/@quantumke" target="_blank" rel="noopener noreferrer">
             Blogs
            </a>
        </li>
        <li className="nav-item-with-tag">
          <Link to='/iyq-2025'>IYQ 2025</Link>
          <span className="new-tag">NEW</span>
        </li>
      </ul>

      <div className="nav-right">
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="join-button-container"
        >
          <Link to='/join-community' className='join-community-nav'>
            Join Us
          </Link>
        </motion.div>

        <button className="menu-toggle" onClick={toggleMenu}>
          <img 
            src={mobileMenu ? closeMenu : menu} 
            alt="menu" 
            className='menu-icon'
          />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;